var path = 'public/app/features/panel/partials/soloPanel.html';
var html = "<div class=\"panel panel--solo\" ng-if=panel style=width:100%>\n\t<plugin-component type=panel>\n\t</plugin-component>\n</div>\n<div class=clearfix></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/panel/partials/soloPanel.html
// module id = 832
// module chunks = 2